/**
 * Тематики локаций — русские названия для фильтров в разделе «Миры».
 *
 * Идентификаторы совпадают с Company::$categoryList на платформе, названия
 * переведены по просьбе Максима 21.08.2026. Перевод живёт здесь, а не в
 * справочнике платформы, намеренно: тот же список читает старый фронт, и
 * переименование там сломало бы ему подписи. Когда старый фронт уйдёт,
 * названия можно будет перенести на платформу и удалить этот файл.
 *
 * Tutorial и Education оба про обучение, поэтому разведены по смыслу:
 * первое — короткие обучающие локации внутри платформы, второе — полноценные
 * образовательные программы.
 */
export const LOCATION_CATEGORIES = [
  { id: 1, title: "Дополненная реальность" },
  { id: 2, title: "Обучалки" },
  { id: 3, title: "Партнёрские" },
  { id: 4, title: "Образование" },
  { id: 5, title: "Фриланс" },
  { id: 6, title: "Мини-игры" },
];

/** Название тематики по её номеру; неизвестный номер названия не получает. */
export const categoryTitle = (id) => {
  const found = LOCATION_CATEGORIES.find((c) => c.id === Number(id));
  return found ? found.title : "";
};
